
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPipeCross as ObiPipeCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pipe-cross.js';
 
 
 

 
 export const ObiPipeCross = createComponent({
   react: React,
   tagName: 'obi-pipe-cross',
   elementClass: ObiPipeCrossElement,
   events: {
     
   }
  });
 
 